<template>
  <div class="homebase-modal-header py-4 px-5">
    <div class="d-flex align-items-center justify-content-between">
      <div>
        <div v-if="logoImgSrc"><img :src="logoImgSrc"></div>
        <div v-if="title" class="homebase-modal-title">{{ title }}</div>
        <div v-if="subtitle" class="homebase-modal-subtitle">
          {{ subtitle }}
        </div>
      </div>
      <div class="close-icon" @click="onModalClose()">
        <img src="@/assets/image/homebase/modal_icon_close.svg" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "modal-header",
  props: ["title", "subtitle", "onModalClose", "logoImgSrc"],
};
</script>

<style scoped>
.homebase-modal-header {
  background: black;
}
.homebase-modal-title,
.homebase-modal-subtitle {
  color: white;
}
.homebase-modal-title {
  font-size: 20px;
  font-family: artifaktElementExtraBold !important;
}
.homebase-modal-subtitle {
  font-size: 16px;
}
.close-icon {
  opacity: 0.6;
  min-width: 22px;
}
.close-icon:hover {
  opacity: 1;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/homebase/modals/ModalHeader.vue